import { Texts, Title, Media, Button } from "../Object";
import { Space } from "../Layout";
import { WorksList } from '../Post';
import Slider from "react-slick";

const Works = () => {
  return(
    <>
      <div className="l-row">
        <Texts slug="title/works" class="c-text--main c-text--en c-text--big"></Texts>
        <Space size={['64px 0 48px', '48px 0 32px']}>
          <div className="p-box__wrap--works-button">
            <Texts slug="works/title" class="c-text--bold"></Texts>
            <div className="pc">
              <Button slug="works" link="/works/"></Button>
            </div>
          </div>
        </Space>
      </div>
      <Space size={['48px 0 0', '48px 0 80px']}>
        <WorksList perPage={6} type="slider"></WorksList>
      </Space>

      <div className="sp">
        <div className="l-row">
          <Button slug="works" link="/works/"></Button>
        </div>
      </div>
        
    </>
  )
}

export default Works;